var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(!_vm.$route.meta['noLayout'])?_c('toolbar'):_vm._e(),(!_vm.$route.meta['noLayout'] && _vm.$route.name != 'index')?_c('global-search'):_vm._e(),_c('router-view',{attrs:{"id":"router"}}),(!_vm.$route.meta['noLayout'])?_c('common-footer',{staticClass:"mt-12 pt-12"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }